import FlagstoneTheme from '../../../Config/flagstoneTheme';
import { Grid, makeStyles } from '@material-ui/core';
import Order from '../../Order/Order';
import React, { useState, useEffect } from 'react';
import BackForwardButton from '../../Shared/BackForwardButton';
import { NavLink } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import AppBar from '@material-ui/core/AppBar';
import Box from '@material-ui/core/Box';
import clsx from 'clsx';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { xsValue } from '../../../Config/constants'
import AutorenewIcon from '@material-ui/icons/Autorenew';
import { dataService } from '../../../Services/data.service';
import { toast } from 'react-toastify';
import { productionOrderStates as state } from '../../../Config/productionOrderStates'
import { scissorTypes } from '../../../Config/scissorStates'
import ScissorStateComponent from '../../Workstation/ScissorStateComponent';
import { machine } from '../../../Config/constants';
import { connect } from 'react-redux';

export const OrderOverviewPage = (props) => {

    const [searchString, setSearchString] = useState("")
    const [productionOrders, setProductionOrders] = useState([])
    const [noOrdersFound, setNoOrdersFound] = useState(false)

    const { t } = useTranslation();
    const classes = useStyles();
    const [value, setValue] = React.useState(0);
    const [timer, setTimer] = React.useState(null);
    const [workstations, setWorkstations] = useState([])

    useEffect(() => {
        let mounted = true
        clearInterval(timer)
        setTimer(null)
        if (mounted) {
            //refresh orders every 15 minutes
            let elapsedTimer = setInterval(() => refreshOrders(), 900000);
            setTimer(elapsedTimer)
        }
        if (searchString) {
            dataService.getProductionOrdersBySearchText(searchString).then(orders => {
                if (!orders) {
                    setNoOrdersFound(true)
                }
                else {
                    setNoOrdersFound(false)
                    if (mounted) {
                        if (JSON.stringify(orders) !== JSON.stringify(productionOrders)) {
                            setProductionOrders(orders)
                        }
                    }
                }

            }).catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })
        }
        else {
            setNoOrdersFound(false)
            dataService.getProductionOrdersByMachine(props.workstation.selectedWorkstation).then(orders => {
                if (mounted) {
                    if (JSON.stringify(orders) !== JSON.stringify(productionOrders)) {
                        setProductionOrders(orders)
                    }
                }
            }).catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })
        }

        dataService.getMachinesByMachineType(machine).then(stations => {
            if (JSON.stringify(stations) !== JSON.stringify(workstations)) {
                setWorkstations(stations)
            }

        }).catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })

        return function cleanup() {
            mounted = false
        }
    }, [searchString]);


    let activeProductionOrders = <React.Fragment></React.Fragment>
    let doneProductionOrders = <React.Fragment></React.Fragment>

    if (props.workstation.activeWorkstations[0]) {
        if (productionOrders) {
            activeProductionOrders = productionOrders.filter(x => x.productionOrderStatus !== state.DONE && x.productionOrderStatus !== state.STOPPED).sort((a, b) => new Date(b.startedOn) - new Date(a.startedOn)).map((order) => (<Grid item key={order.id} className={classes.gridmargin} xs={xsValue}><Order key={order.id} actions={props.actions} productionOrder={order} {...props}></Order></Grid>));
            doneProductionOrders = productionOrders.filter(x => x.productionOrderStatus === state.DONE || x.productionOrderStatus === state.STOPPED).sort((a, b) => new Date(a.startedOn) - new Date(b.startedOn)).map((order) => (<Grid item key={order.id} className={classes.gridmargin} xs={xsValue}><Order key={order.id} actions={props.actions} productionOrder={order} {...props}></Order></Grid>));
        }
        if (searchString && !noOrdersFound) {
            activeProductionOrders = productionOrders.sort((a, b) => new Date(a.startedOn) - new Date(b.startedOn)).map((order) => (<Grid item key={order.id} className={classes.gridmargin} xs={xsValue}><Order key={order.id} actions={props.actions} productionOrder={order} {...props}></Order></Grid>));
            doneProductionOrders = activeProductionOrders
        }
        if (noOrdersFound) {
            doneProductionOrders = <div className={classes.noOrdersFound}>{t("No orders found for the search criteria entered")}</div>
            activeProductionOrders = doneProductionOrders
        }
    }

    function searchOrder(e) {
        setSearchString(e.target.value)
    }

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    function TabPanel(props) {
        const { children, value, index, ...other } = props;

        return (
            <div
                role="tabpanel"
                hidden={value !== index}
                id={`simple-tabpanel-${index}`}
                aria-labelledby={`simple-tab-${index}`}
                {...other}
            >
                {value === index && (
                    <Box p={3}>
                        {children}
                    </Box>
                )}
            </div>
        );
    }

    function refreshOrders() {
        dataService.getProductionOrdersByMachine(props.workstation.selectedWorkstation).then(orders => {
            if (JSON.stringify(orders) !== JSON.stringify(productionOrders)) {
                setProductionOrders(orders)
            }

        }).catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })
    }

    function a11yProps(index) {
        return {
            id: `simple-tab-${index}`,
            'aria-controls': `simple-tabpanel-${index}`,
        };
    }

    return <div className={classes.backGround}>
        <div className={classes.spacer80}>
            <div className={classes.left}>
                <NavLink className={classes.navButton} to={`/`}>
                    <BackForwardButton direction={'Back'} textOverride={t("Back to workstations")}></BackForwardButton>
                </NavLink>
                <div className={classes.title}>{t('Production queue')}</div>
            </div>
            <div className={classes.right}>
                <div className={classes.searchContainer}>
                    <TextField
                        className={classes.search}
                        id="input-with-icon-textfield"
                        variant="outlined"
                        size="small"
                        onChange={(e) => searchOrder(e)}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <img className={classes.eye} src={process.env.PUBLIC_URL + '/img/search.svg'} alt={""}></img>
                                </InputAdornment>
                            ),
                        }}>
                    </TextField>
                    <button className={classes.refreshButton} onClick={() => refreshOrders()}>
                        <AutorenewIcon className={classes.refreshIcon}></AutorenewIcon>
                        <div className={classes.refreshText}>{t("REFRESH")}</div>
                    </button>
                </div>
                <div className={classes.scissorStatusContainer}>
                    {workstations.length > 0
                        ?
                        <div className={classes.upperScissor}>
                            <ScissorStateComponent size={"M"} machineNumber={workstations.find(x => x.id === props.workstation.selectedWorkstation).code.match(/\d/g).join("")} scissorStatus={props.workstationState.workstationsWithScissorStatusInfo.find(x => x.id === props.workstation.selectedWorkstation).scissorStatuses.find(x => x.scissorName === scissorTypes.UPPER)}></ScissorStateComponent>
                        </div>
                        :
                        <React.Fragment></React.Fragment>}
                    {workstations.length > 0
                        ?
                        <div className={classes.lowerScissor}>
                            <ScissorStateComponent size={"M"} machineNumber={workstations.find(x => x.id === props.workstation.selectedWorkstation).code.match(/\d/g).join("")} scissorStatus={props.workstationState.workstationsWithScissorStatusInfo.find(x => x.id === props.workstation.selectedWorkstation).scissorStatuses.find(x => x.scissorName === scissorTypes.LOWER)}></ScissorStateComponent>
                        </div>
                        :
                        <React.Fragment></React.Fragment>}
                </div>
            </div>
        </div>
        <AppBar position="static" className={classes.appBar}>
            <Tabs value={value} onChange={handleChange} aria-label="simple tabs example">
                <Tab label={t("ACTIVE")} {...a11yProps(0)} className={clsx({ [classes.activeTab]: value === 0, [classes.notActiveTab]: value !== 0 })} />
                <Tab label={t("DONE")} {...a11yProps(1)} className={clsx({ [classes.activeTab]: value === 1, [classes.notActiveTab]: value !== 1 })} />
            </Tabs>
        </AppBar>
        <TabPanel value={value} index={0}>
            <Grid container spacing={3} className={classes.grid}>
                {activeProductionOrders.length > 0 ? activeProductionOrders 
                : <div className={classes.noFinishedOrders}>{t("noActiveOrders")}</div>}
            </Grid>
        </TabPanel>
        <TabPanel value={value} index={1}>
            <Grid container spacing={3} className={classes.grid}>
                {doneProductionOrders.length > 0 
                ? doneProductionOrders 
                :<div className={classes.noFinishedOrders}>{t("noFinishedOrders")}</div>
            }
            </Grid>
        </TabPanel>
    </div>
}

const useStyles = makeStyles({
    spacer80: {
        height: '80px'
    },
    backGround: {
        paddingRight: "1%",
        paddingTop: "20px",
        position: "relative",
        top: "40px"
    },
    noFinishedOrders:{
        border: "1px dashed grey",
        width: '100%',
        padding: '10px',
        marginLeft: '10px',
        borderRadius: "5px",
        backgroundColor: 'white',
    },

    gridmargin: {
        minWidth: "450px",
        height: "155px",
        paddingBottom: "1.5% !important",
        paddingRight: "0.8% !important",
        marginBottom: "1.5% !important",
        boxSizing: 'border-box'
    },
    navButton: {
        textDecoration: "none",
        border: "none",
        outline: "none",
        marginLeft: "18px"
    },
    workstation: {
        height: "100px",
        margin: "20px",
        fontSize: "20pt",
        textAlign: "center",
        fontWeight: "bold",
        color: FlagstoneTheme.primaryColor,
        textDecoration: 'none'
    },

    title: {
        fontSize: "32px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        color: "#000000",
        paddingLeft: "5px",
        marginLeft: "20px"
    },
    date: {
        fontSize: "15px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        color: "#8D8D8D",
        marginTop: "4px",
        paddingLeft: "7px",
        marginBottom: "3px",
        marginLeft: "20px"
    },
    search: {
        backgroundColor: "white",
        top: "5px",
        right: "30px"
    },
    left: {
        width: "auto",
        height: "70px",
        float: 'left'
    },
    right: {
        width: "auto",
        height: "90px",
        float: 'right',
        textAlign: "right"
    },
    appBar: {
        backgroundColor: "rgba(1,1,1,0)",
        boxShadow: "none",
        color: "#020100",
        "& > div > div > span": {
            backgroundColor: FlagstoneTheme.palette.primary.main,
            height: "3px",
            width: "80px !important"
        },
        borderBottom: "1px solid #e3e0de",
        marginLeft: "30px",
        width: "97%",
        overflow: "visible"

    },
    activeTab: {
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        color: FlagstoneTheme.palette.primary.main,
        fontWeight: 'bold',
        paddingBottom: "0px",
        minWidth: "80px !important"
    },
    notActiveTab: {
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        paddingBottom: "0px",
        minWidth: "80px !important"
    },
    refreshButton: {
        width: "130px",
        height: "40px",
        border: "none",
        outline: "none",
        backgroundColor: FlagstoneTheme.palette.primary.main,
        borderRadius: "5px",
        marginTop: "15px",
        cursor: "pointer",
        zIndex: "999",
        position: "relative",
        right: "30px"
    },
    refreshIcon: {
        color: "white",
        float: "left",
        marginLeft: "10px",
        marginRight: "5px"

    },
    refreshText: {
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        color: "white",
        float: "left",
        paddingTop: "3px",
        cursor: "pointer"

    },
    noOrdersFound: {
        fontSize: "18px",
        fontFamily: "Lato, sans-serif",
        color: "#8D8D8D",
        padding: "10px",
        marginLeft: "10px"

    },
    scissorStatusContainer: {
        width: "65%",
        float: "right",
        height: "90px",
        paddingTop: "5px",
        boxSizing: "border-box"
    },
    searchContainer: {
        width: "200px",
        float: "right",
        height: "90px"

    },
    upperScissor: {
        height: "40px",
        width: "90%"
    },
    lowerScissor: {
        height: "40px",
        width: "90%"
    }
});

function mapStateToProps(state) {
    return {
        workstationState: state.workstationState
    }
}

export default connect(mapStateToProps)(OrderOverviewPage)